import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Typography, Button } from "@material-ui/core";
import styled from "styled-components";

const StyledTypography = styled(Typography)`
    margin-top: 20px !important;
`;
export default props => {
    const [secondClick, setSecondClick] = useState(false);

    const firstMessage = (
        <StyledTypography variant="body2">
            <b>
                Removing a Qualification From Assigned Qualifications Will
                Delete All Associated Qualification Data For All Users.
            </b>
        </StyledTypography>
    );

    const secondMessage = (
        <StyledTypography variant="body2">
            <b>Removing A Qualification Is Non Reversible!</b>
        </StyledTypography>
    );

    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader>Remove Qualification</ModalHeader>
            <ModalBody>
                {secondClick ? secondMessage : firstMessage}{" "}
                <StyledTypography variant="body2">
                    Are You Sure You Wish To Proceed
                </StyledTypography>
                <StyledTypography variant="body2">
                    Title: <b>{props.qualification.qualification_title}</b>
                </StyledTypography>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={() => {
                        setSecondClick(false);
                        props.setModalState(false);
                    }}
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        if (secondClick) {
                            props.removeQualification(props.qualification);
                            setSecondClick(false);
                            props.setModalState(false);
                        } else {
                            setSecondClick(true);
                        }
                    }}
                    variant="contained"
                    color="primary"
                >
                    Remove
                </Button>
            </ModalFooter>
        </Modal>
    );
};
